
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import UserInterface from "../../interfaces/User";

const Auth = namespace("Auth");

@Component({})
export default class LoginFormComponent extends Vue {
  @Auth.Action
  private login!: (data: any) => Promise<any>;

  @Auth.Getter
  private isLoggedIn!: boolean;

  user = {} as UserInterface;

  isFormValid = false;
  pwdBtnVisib = false;
  isLogginIn = false;

  regras = {
    vazio: (v: string) => {
      return !!v || "Campo obrigatório";
    },
    senha: (v: string) => {
      return !!v || "Informe a senha";
    },
  };

  criarCadastro(evento: any) {
    if (!evento) return;
    this.$emit("onCriarCadastroRequest");
  }

  recuperarSenha(evento: any) {
    if (!evento) return;
    this.$emit("onRecuperarSenhaRequest");
  }

  efetuarLogin() {
    this.isLogginIn = true;

    if (this.user.username && this.user.password) {
      this.login(this.user)
        .then((data) => {
          if (data.status == 200) this.$emit("onUserLoginSuccess");
          else if (data.status == 202) {
            this.$emit("onPasswordChangeRequested");
          }
        })
        .finally(() => {
          this.isLogginIn = false;
        });
    }
  }

  reset() {
    this.user = {} as UserInterface;
    this.isFormValid = false;
    this.pwdBtnVisib = false;
    this.isLogginIn = false;
  }

  mounted() {
    this.reset();
  }
}
